import Dialog, { type DialogProps } from '@/components/Dialog';
import styled from '@emotion/styled';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import mediaQuery from '@/lib/styling/mediaQuery';
import type React from 'react';

const StyledDialog = styled(Dialog)<DialogProps>(
  {
    '.MuiDialog-paper': {
      width: 'auto',
      maxWidth: 1240,
      display: 'block',
      [mediaQuery(1450)]: {
        maxWidth: 'calc(90% - 64px)',
      },
      [mediaQuery(1100)]: {
        maxWidth: 'calc(100% - 64px)',
      },
      [mediaQuery(480)]: {
        maxWidth: 'calc(100% - 24px)',
      },
      '> footer': {
        flexWrap: 'wrap',
      },
    },
    '.MuiDialogContent-root': {
      flexShrink: 0,
    },
  },
  addHighContrastStyles(({ theme }) => ({
    '.MuiDialog-paper': {
      border: `2px solid ${theme.palette.divider}`,
    },
  })),
);

type PickerDialogProps = Omit<
  DialogProps,
  'onKeyDownCapture' | 'onKeyUpCapture'
> & {
  onClose: () => void;
};

const PickerDialog = ({ onClose, ...props }: PickerDialogProps) => (
  <StyledDialog
    onClose={onClose}
    // We need this to prevent the menu focus management from breaking the
    // dialog focus management
    onKeyDownCapture={(e: React.KeyboardEvent<HTMLDivElement>): void => {
      e.stopPropagation();

      if (e.key === 'Escape') {
        onClose();
      }
    }}
    onKeyUpCapture={(e: React.KeyboardEvent<HTMLDivElement>): void => {
      e.stopPropagation();
    }}
    {...props}
  />
);

export default PickerDialog;
